import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing.vue'
import Home from '../views/Home.vue'
import Projects from '../views/Projects.vue'
import Project from '../views/Project.vue'
import Practice from '../views/Practice.vue'
import Journal from '../views/Journal.vue'
import JournalEntry from '../views/JournalEntry.vue'
import Contact from '../views/Contact.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/project/:id',
    name: 'Project',
    component: Project
  },
  {
    path: '/practice',
    name: 'Practice',
    component: Practice
  },
  {
    path: '/journal',
    name: 'Journal',
    component: Journal
  },
  {
    path: '/journalentry/:id',
    name: 'JournalEntry',
    component: JournalEntry
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return desired position
    return { x: 0, y: 0 }
  }
})

export default router
